import { h, ref, onMounted, onUpdated, onBeforeUnmount } from "vue";

const VueAutoHeight = {
  name: "VueAutoHeight",
  props: {
    expanded: {
      type: Boolean,
      default: false,
    },
  },
  setup(props: any, _ref: any) {
    const { slots } = _ref;
    const containerElRef = ref(null);

    const UpdateHeight = () => {
      containerElRef.value.style.maxHeight = props.expanded ? containerElRef.value.scrollHeight + "px" : 0;
    };
    const onResize = () => {
      UpdateHeight();
    };

    onUpdated(() => {
      UpdateHeight();
    });
    onMounted(() => {
      containerElRef.value.style.overflow = "hidden";
      UpdateHeight();
      window.addEventListener("resize", onResize);
    });
    onBeforeUnmount(() => {
      window.removeEventListener("resize", onResize);
    });

    return () => {
      return h(
        "div",
        {
          class: "auto-height",
          ref: containerElRef,
        },
        slots.default && slots.default()
      );
    };
  },
};
export { VueAutoHeight };
